// extracted by mini-css-extract-plugin
export default {"pagination":"page_pagination__OkHbL","page-link":"page_page-link__Hg7S4","tablerows":"page_tablerows__p7mT-"};